import type { Deal } from '@backmarket/nuxt-layer-cms/products/algolia/types'

import type { Granularity } from '../models/product'

export type Experiments = Record<string, string | undefined>

export function selectEligibleDeal(
  deals: Deal[] | undefined,
  granularity: Granularity | undefined,
  withDeal: boolean,
  excludedDealTypes: Deal['type'][],
  experiments: Experiments,
): Deal | undefined {
  if (!withDeal || !deals?.length) return undefined

  const deal = deals[0]

  if (excludedDealTypes.includes(deal.type)) return undefined

  if (deal.type === 'manual_promo_code') {
    return (granularity === 'parent' || granularity === 'backbox') &&
      experiments['experiment.manualPromoCode'] === 'enabled'
      ? deal
      : undefined
  }

  if (granularity !== 'backbox') return undefined

  if (
    deal.type === 'flash_sales' &&
    experiments['experiment.flashSales'] === 'enabled'
  ) {
    return deal
  }

  if (deal.type === 'seller_flash_sales' && deal.percentage?.value) {
    return deal
  }

  return undefined
}
